import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuModel } from "../../models/menus/menu.model";
import { DialogService } from "primeng/dynamicdialog";
import { CurrentVenueHelperService } from "../../../share-modul/services/current-venue-helper/current-venue.helper.service";
import { Subject, Subscription, takeUntil } from "rxjs";
import { MenuService } from "../../services/menus/menu.service";
import { MessageService } from "primeng/api";
import { Router } from "@angular/router";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-manager-menus',
  templateUrl: './manager-menus.component.html',
  styleUrls: ['./manager-menus.component.scss']
})
export class ManagerMenusComponent implements OnInit, OnDestroy {


  public unsubscribe: Subject<void> = new Subject<void>();
  public listAllMenus: Array<MenuModel> = new Array<MenuModel>();
  public spinner: boolean;
  public venueId: string | null;
  public venueIdUpdateSubscription: Subscription;
 

  constructor(
    public dialogService: DialogService,
    public messageService: MessageService,
    public menuService: MenuService,
    public currentVenueHelper: CurrentVenueHelperService,
    public router: Router,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if(params['venue-id'] != null){
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
        this.getMenus(params['venue-id']);       
      }
    });
  }


  getMenus(venueId: string): void {
    this.listAllMenus = new Array<MenuModel>();
    this.spinner = true;
    this.menuService.listAllMenusForVenue(venueId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          response.forEach((menu: MenuModel) => {
            let currentMenu = new MenuModel();
            currentMenu.id = menu.id;
            currentMenu.name = menu.name;
            currentMenu.createDate = menu.createDate;
            currentMenu.venueMenuCategories = menu.venueMenuCategories.map(x => x.name);
            this.listAllMenus.push(currentMenu);
          });
          this.spinner = false;
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }

  public navigateToDetails(id: string): void {
    this.router.navigate([this.venueId, 'manager-menus', id, 'details']);
  }

  ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }

}
